import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { useEffect, useState } from "react";

ChartJS.register(ArcElement, Tooltip, Legend);

ChartJS.defaults.font.family = "Nunito";
ChartJS.defaults.font.size = 10;

const GaugeConRate = ({ conversionRate }) => {
  const [gradient, setGradient] = useState(null);
  useEffect(() => {
    const ctx = document.getElementsByTagName("canvas")[4].getContext("2d");
    const gradientSegment = ctx.createLinearGradient(0, 0, 700, 0);
    gradientSegment.addColorStop(0, "#fccacc");
    gradientSegment.addColorStop(0.2, "#9aa4f1");
    gradientSegment.addColorStop(1, "#5b79ff");
    setGradient(gradientSegment);
  }, []);
  /* const ctx= div.getElementsByTagName("canvas")[0].
   */
  console.log(conversionRate, "conversionRate in GaugeConRate");

  let scoreArray;
  if (conversionRate < 100) {
    scoreArray = [conversionRate, 100 - conversionRate];
  } else if (conversionRate >= 100) {
    scoreArray = [100, 0];
  }

  const data = {
    labels: ["On loan", "Paid"],
    datasets: [
      {
        label: "Amount",
        data: scoreArray,
        /*  backgroundColor: ["#FBDC8C", "#FBF5E3"], */
        backgroundColor: [gradient, "#E9E9E9"],
        borderWidth: 1,
        cutout: "60%",
        circumference: 180,
        rotation: 270,
        borderRadius: 0,
        /*  hoverBackgroundColor: ["rgba(255, 206, 86, 0.9)", "rgba(54, 162, 235, 0.9)", "rgba(255, 99, 132, 0.9)"], */
      },
    ],
  };

  const gaugeTextPlugin = {
    id: "gaugeTextPlugin",
    afterDraw: (chart, args, pluginOptions) => {
      const {
        ctx,
        data,
        chartArea: { top, bottom, left, right, width, height },
        scales: { r },
      } = chart;
      ctx.save();
      const center = chart.getDatasetMeta(0).data[0].getCenterPoint().x;
      const xCor = chart.getDatasetMeta(0).data[0].x;
      const yCor = chart.getDatasetMeta(0).data[0].y;
      let score = data.datasets[0].data[0];
      let rating;

      if (score <= 50) {
        rating = "Low";
      } else if (score <= 75) {
        rating = "Average";
      } else {
        rating = "High";
      }
      ctx.font = "10px Arial";
      ctx.fillstyle = "black";
      ctx.textAlign = "left";
      ctx.fillText("0", left, yCor + 20);
      ctx.textAlign = "right";
      ctx.fillText("100", right, yCor + 20);

      ctx.font = "10px Nunito";
      ctx.textAlign = "center";
      ctx.fillText(rating, xCor, yCor - 30);

      ctx.textAlign = "center";
      ctx.font = "26px Nunito bolder";
      ctx.fillText(score, xCor, yCor);
    },
  };

  const plugins = [gaugeTextPlugin];

  const options = {
    plugins: {
      legend: {
        display: false,
        position: "bottom",
        align: "start",
        labels: {
          boxWidth: 8,
        },
      },

      title: {
        display: false,
      },
      tooltip: {
        display: false,
        displayColors: false,
        enabled: false,
      },
    },
  };
  return (
    <div id='gaugeMedh' style={{ marginTop: "-20px" }} className='DoughnutChart'>
      <Doughnut data={data} options={options} plugins={plugins} />
    </div>
  );
};

export default GaugeConRate;
